import {maxLength, required} from '@vuelidate/validators';
import type {Ref} from 'vue';
import {computed, ref} from 'vue';
import type {FormElementItem} from '~/lib/types/formTypes';
import type {RieCommand, SectorResource} from '~/lib/types/rieTypes';

export const rieCommandFormLabels = {
	title: 'Naam RI&E',
	sectorKeys: 'Actieve sectoren'
} as const satisfies Partial<Record<keyof RieCommand, string>>;

export const useRieForm = (sectors: Ref<Array<SectorResource>>, initialValue?: RieCommand) => {
	const sectorOptions = computed<Array<{ label: string, value: string }>>(() => {
		return sectors.value
			.map((sector) => {
				return {label: sector.title, value: sector.key};
			});
	});

	const formSchema: Array<FormElementItem> = [
		{
			type: 'text',
			label: rieCommandFormLabels.title,
			key: 'title',
			validators: {
				required,
				maxLength: maxLength(255)
			}
		}
	];

	// the sectors field is only shown when there are sectors available
	if (sectorOptions.value.length > 0) {
		formSchema.push({
			type: 'checkbox',
			label: rieCommandFormLabels.sectorKeys,
			key: 'sectorKeys',
			options: sectorOptions,
			validators: {
				required
			}
		});
	}

	const getFormFields = (): RieCommand => {
		if (!initialValue) {
			return {
				title: '',
				sectorKeys: []
			} satisfies RieCommand;
		}
		return initialValue;
	};

	return {
		formSchema,
		formFields: ref(getFormFields())
	};
};
